import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

/**
 * OAuth provider types supported by the API
 */
export enum OAuthProvider {
  JIRA = 'JIRA',
  QUICK_BOOKS = 'QUICK_BOOKS',
}

/**
 * Response from OAuth URL generation endpoint
 */
export interface GenerateOAuthUrlResponse {
  url: string;
}

/**
 * Request body for OAuth callback
 */
export interface OAuthCallbackRequest {
  state: string;
  code: string;
  realmId?: string;
}

/**
 * Response from OAuth callback
 */
export interface StatusResponse {
  status: string;
}

/**
 * Generates OAuth URL for the specified provider
 * @param provider - OAuth provider (JIRA or QUICK_BOOKS)
 * @returns OAuth URL to redirect user to
 */
export const generateOAuthUrl = async (provider: OAuthProvider): Promise<string> => {
  const endpoint = '/api/integrations/oauth/url';

  const response = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.INTEGRATION_OAUTH_URL_FAILED,
    () => axiosInstance.get<{ data: GenerateOAuthUrlResponse }>(endpoint, { params: { provider } })
  );

  return response.url;
};

/**
 * Completes OAuth callback flow
 * @param request - OAuth callback parameters
 */
export const completeOAuthCallback = async (request: OAuthCallbackRequest): Promise<void> => {
  const endpoint = '/api/integrations/oauth/callback';

  await withApiErrorHandler(endpoint, ApiErrorCode.INTEGRATION_OAUTH_CALLBACK_FAILED, () =>
    axiosInstance.post(endpoint, request)
  );
};
